export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const UPDATE_BASIC_DETAILS = 'UPDATE_BASIC_DETAILS';
export const UPDATING_BASIC_DETAILS = 'UPDATING_BASIC_DETAILS';

export const UPDATE_DELIVERY_INFO = 'UPDATE_DELIVERY_INFO';
